<div class="backgroundColor shark lighten-1">
  <section class="top-119 position-relative">
    <div class="container-fluid backgroundColor mine-shaft darken-4 pt-24 pb-10">
      <div class="row">
        <div class="col-12">
          <h1 class="position-relative d-flex justify-content-end textColor harvest-gold base right-align">
            <ng-container *ngFor="let item of links">
              <a href="{{item.link}}" class="a-font-style link-gold">{{item.name}}</a>
              &nbsp;
              <span>/&nbsp;</span>
            </ng-container>
            <span class="h1 text-limit"> {{current}}</span>
          </h1>
        </div>
      </div>
    </div>
  </section>
</div>